module.exports = ".mat-elevation-z8{padding:30px}\n"